import { Module } from 'vuex';

import { RootState } from 'frontend/types';
import Vue from 'vue';

interface ShowShoppingVersion {
  showShoppingVersion: boolean;
}

const showShoppingVersion: Module<ShowShoppingVersion, RootState> = {
  namespaced: true,
  state: () => ({
    showShoppingVersion: false,
  }),
  getters: {
    showShoppingVersion: state => state.showShoppingVersion,
  },
  mutations: {
    setValue(state: ShowShoppingVersion, value: { value: boolean }): void {
      Vue.set(state, 'showShoppingVersion', value.value);
    },
  },
};

export default showShoppingVersion;
